export default {
  data: null,
  columns: [
    {
      label: '姓名',
      prop: 'name'
    },
    {
      label: '账号',
      prop: 'accout'
    },
    {
      label: '场地名称',
      prop: '__name__'
    },
    {
      label: '场地ID',
      prop: '__id__'
    },
    {
      label: '场地属性',
      prop: '__type__'
    },
    {
      label: '场地号',
      prop: '__fieldNo__'
    },
    {
      label: '日期',
      prop: '__day__'
    },
    {
      label: '时间段',
      prop: '__time__'
    },
    {
      label: '申请时间',
      prop: 'applyTime'
    },
    {
      label: '支付金额(元)',
      prop: 'payAmount'
    },
    {
      label: '退款比例(%)',
      prop: 'refundProportion'
    },
    {
      label: '退款金额(元)',
      prop: 'refundMoney'
    },
    {
      label: '状态',
      prop: 'statusName'
    },
    {
      label: '退款原因',
      prop: 'refundDesc'
    }
  ]
}
